import { useMemo } from 'react';

type Platform = 'web' | 'mobile';

export const usePlatform = (): Platform => {
  return useMemo(() => {
    if (typeof window === 'undefined') {
      return 'mobile';
    }

    if (typeof window !== 'undefined' && window.document) {
      return 'web';
    }

    return 'mobile';
  }, []);
};
